import type { EventDay } from 'library/types/events';
import type { Day } from 'library/models/events';

import { getHours, getMinutes, parse, setHours, setMinutes } from 'date-fns';

const normalizeTimetable = (table: Day[]) => {
	let timetable: EventDay[] = [];

	timetable = table?.map((day) => {
		const date = parse(day.date, 'dd.MM.yyyy', new Date());
		const startHours = getHours(parse(day.time_from, 'HH:mm', new Date()));
		const startMinutes = getMinutes(parse(day.time_from, 'HH:mm', new Date()));
		const endHours = getHours(parse(day.time_to, 'HH:mm', new Date()));
		const endMinutes = getMinutes(parse(day.time_to, 'HH:mm', new Date()));
		const from = setMinutes(setHours(date, startHours), startMinutes);
		const to = setMinutes(setHours(date, endHours), endMinutes);
		return {
      time_from_day: from,
			time_from: from,
			time_to: to,
		};
	});
	return [...timetable];
};

export default normalizeTimetable;
